import React, { memo, forwardRef } from 'react';
import { AuthCustomAction } from '@redlink/components/muscles';
import { AuthPageContainerTemplate } from '@redlink/components/templates';
import { useLocale } from '@redlink/assets/locale';

export const AuthPageContainer = memo(
  forwardRef(({ onLoginPress, onRegisterPress, isBusy, children }, ref) => {
    const { dictionary } = useLocale();

    return (
      <AuthPageContainerTemplate
        {...{ isBusy, ref }}
        title={dictionary.login}
        actions={[
          {
            title: dictionary.register,
            variant: 'custom',
            children: (
              <AuthCustomAction
                title={dictionary.dontHaveAccount}
                subtitle={dictionary.registerFromHere}
                onPress={onRegisterPress}
              />
            ),
          },
          {
            title: dictionary.login,
            variant: 'primary',
            onPress: onLoginPress,
          },
        ]}
      >
        {children}
      </AuthPageContainerTemplate>
    );
  })
);
